import Base from './base'

/** People-tab `filters`, or companies-list (Radar) `companyFilters`; exactly one. */
export interface ISaveCampaignRulePayload {
  ruleId?: string
  name: string
  filters?: object
  companyFilters?: object
}

export default class Campaigns extends Base {
  list(data: object = {}) {
    return this.apiClient.get('crm/campaigns', data)
  }

  create(data: object) {
    return this.apiClient.post('crm/campaigns', data)
  }

  show(id: string) {
    return this.apiClient.get(`crm/campaigns/${id}`)
  }

  update(id: string, data: object) {
    return this.apiClient.put(`crm/campaigns/${id}`, data)
  }

  listMembers(id: string, data: object = {}) {
    return this.apiClient.get(`crm/campaigns/${id}/members`, data)
  }

  addMembers(id: string, data: object) {
    return this.apiClient.post(`crm/campaigns/${id}/members`, data)
  }

  updateMember(campaignId: string, memberId: string, data: object) {
    return this.apiClient.put(`crm/campaigns/${campaignId}/members/${memberId}`, data)
  }

  updateMembersStatus(campaignId: string, data: { ids: string[]; status: string }) {
    return this.apiClient.put(`crm/campaigns/${campaignId}/members`, data)
  }

  removeMember(campaignId: string, memberId: string) {
    return this.apiClient.delete(`crm/campaigns/${campaignId}/members/${memberId}`)
  }

  listReferrals(id: string) {
    return this.apiClient.get(`crm/campaigns/${id}/referrals`)
  }

  listExpenses(id: string) {
    return this.apiClient.get(`crm/campaigns/${id}/expenses`)
  }

  listRules(id: string) {
    return this.apiClient.get(`crm/campaigns/${id}/rules`)
  }

  saveRule(campaignId: string, data: ISaveCampaignRulePayload) {
    const { ruleId, ...body } = data
    return ruleId
      ? this.apiClient.put(`crm/campaigns/${campaignId}/rules/${ruleId}`, body)
      : this.apiClient.post(`crm/campaigns/${campaignId}/rules`, body)
  }

  deleteRule(campaignId: string, ruleId: string) {
    return this.apiClient.delete(`crm/campaigns/${campaignId}/rules/${ruleId}`)
  }
}
